import { render, staticRenderFns } from "./LikertEdit.vue?vue&type=template&id=76487126&"
import script from "./LikertEdit.vue?vue&type=script&lang=js&"
export * from "./LikertEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports